module.exports = __webpack_public_path__ + "img/5.e0f62691.png";